import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthentication } from "../../hooks/useAuthentication";

const ProtectedRoute = ({ children }) => {
  const { userId } = useAuthentication();

  if (userId === null) {
    return <div>Carregando...</div>;
  }

  if (!userId) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
